module.exports = __webpack_public_path__ + "img/FC_Team.9335ea2e.svg";